import { Stack, useTheme } from "@mui/material"
import { TruncatedTypography } from "lib/@components/truncated-typography"
import Iconify from "minimals-template/components/Iconify"

export function BaseComponentSummaryValue({ label, value, icon, palette = "primary", color: providedColor, sx = {} }) {
    const theme = useTheme()
    const color = providedColor ?? theme.palette[palette]?.main ?? theme.palette.primary.main

    return (
        <Stack sx={{ minWidth: 0, position: "relative", pt: 4, ...sx }}>
            <Iconify
                icon={icon}
                sx={{
                    borderRadius: "50%",
                    color,
                    height: 20,
                    width: 20,
                    mb: 0.5,
                }}
            />
            <TruncatedTypography variant="caption" color="text.secondary">
                {label}
            </TruncatedTypography>
            <TruncatedTypography variant="body1" fontWeight={500}>
                {value || "—"}
            </TruncatedTypography>
        </Stack>
    )
}
